import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as solidStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as regularStar } from "@fortawesome/free-regular-svg-icons";

export default function StarRating ( { rating = 0 } )
{
    const filled = Math.min( Math.round( rating ) || 0, 5 );

    return (
        <div className="star-rating" aria-label={ `${ filled } out of 5` }>
            { Array.from( { length: filled } ).map( ( _, i ) => (
                <FontAwesomeIcon key={ `f${ i }` } icon={ solidStar } className="star star--filled" />
            ) ) }
            { Array.from( { length: 5 - filled } ).map( ( _, i ) => (
                <FontAwesomeIcon key={ `e${ i }` } icon={ regularStar } className="star star--empty" />
            ) ) }
        </div>
    );
}
